export default "__VITE_ASSET__CZZVCAXx__"